import * as React from 'react'

import Grid                 from '@material-ui/core/Grid'
import Typography           from '@material-ui/core/Typography'
import { withFormik }       from 'formik'
import { FormattedMessage } from 'react-intl'

import { ActionButton, InlineError, LoadingOverlay } from '../atoms'
import loadable                                      from '../hocs/loadable'
import { PersonalChunk }                             from './chunks'
import {
  genValueMapper,
  proxyFormikSubmission,
}                                                    from './form-utils'
import {
  emptyPersonalInfo,
  personalSchema,
}                                                    from './schemas'
import { PersonalFields }                            from './types'

const PersonalInformationEditForm = withFormik<any, PersonalFields>({
  validationSchema: personalSchema,
  mapPropsToValues: genValueMapper(emptyPersonalInfo),
  handleSubmit:     proxyFormikSubmission,
})(
  props => {
    const phrasing = {
      editPersonal: <FormattedMessage id={'generic.editPersonal'} />,
    }

    const {
      fetching,
      error,
      handleSubmit,
      ...rest
    } = props

    return (
      <LoadingOverlay show={fetching}>
        <Grid container direction={'column'} spacing={24}>
          <Grid item>
            <Typography variant={'title'}>
              {phrasing.editPersonal}
            </Typography>
          </Grid>

          <Grid item>
            <form onSubmit={handleSubmit}>
              <Grid container direction={'column'} spacing={24}>
                <Grid item>
                  <PersonalChunk {...rest} />
                </Grid>

                {error && (
                  <Grid item>
                    <Typography color={'error'} gutterBottom>
                      <InlineError i18nErrorId={error} />
                    </Typography>
                  </Grid>
                )}

                <Grid item>
                  <ActionButton
                    type={'submit'}
                    actionType={'update'}
                    variant={'raised'}
                    color={'secondary'}
                  />
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </LoadingOverlay>
    )
  },
)

export default loadable(PersonalInformationEditForm)



// WEBPACK FOOTER //
// ./src/components/forms/PersonalInformationEditForm.tsx